import { handleActions } from 'redux-actions';
import { sum } from 'lodash-es';

import { GenderValue, GenderFilterCount } from 'ha/types/SearchFilters';

import { GenderFilterState } from './Types';
import { Actions } from '../constants';

const initialState = {
  listingCount: {},
  value: [],
  isHidden: false,
};

interface Payload {
  filtersCount: {
    gender: GenderFilterCount;
  };
  globalFiltersCount: {
    gender: GenderFilterCount;
  };
  gender: GenderValue;
}

export default handleActions<GenderFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.gender,
      isHidden: sum(Object.values(payload.globalFiltersCount.gender)) === 0,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (state, { payload: { gender = [] } }) => ({
      ...state,
      value: Array.isArray(gender) ? gender : [gender],
    }),
  },
  initialState,
);

export const getGenderFilter = (state: GenderFilterState) => state.value;
